import { useEffect, useState } from 'react';
import './index.css';

export const withFadeIn = <P extends object>(
  WrappedComponent: React.ComponentType<P>
) => {
  const FadeInComponent = (props: P) => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
      setTimeout(() => {
        setIsVisible(true);
      }, 100);
    }, []);

    return (
      <div className={`fadeIn ${isVisible ? 'visible' : ''}`}>
        <WrappedComponent {...props} />
      </div>
    );
  };

  return FadeInComponent;
};
